import {
  googleAccounts,
  googleProperties,
  isLoadingAccounts,
  isLoadingProperties,
  accountError,
  propertyError,
  selectedAccountId,
  selectedPropertyId,
  currentView,
  isAddingNewAccount,
  isProcessingAccountSelection,
  isSavingProperty
} from './state'

import { loadGoogleAccounts } from './methods/load-accounts'
import { loadGoogleProperties } from './methods/load-properties'
import { selectAccount } from './methods/select-account'
import { selectProperty } from './methods/select-property'
import { accountSelected } from './methods/account-selected'
import { saveGooglePropertySelection } from './methods/save-property-selection'
import { goBackToAccounts } from './methods/go-back-to-accounts'
import { connectToGoogle } from './methods/connect-to-google'
import { addNewGoogleAccount } from './methods/add-new-google-account'
import { closeGoogleStatusModal } from './methods/close-google-status-modal'
import { revokeAccount } from './methods/revoke-account'
import { checkDuplicateAccount } from './methods/check-duplicate-account'
import { useI18n } from 'vue-i18n'

/**
 * Google integration composable for handling Google-specific integration logic
 */
export default function useGoogleIntegration() {
  // Setup fonksiyonu içinde kullanılan composable
  const { t } = useI18n()
  
  return {
    // State
    googleAccounts,
    googleProperties,
    isLoadingAccounts,
    isLoadingProperties,
    accountError,
    propertyError,
    selectedAccountId,
    selectedPropertyId,
    currentView,
    isAddingNewAccount,
    isProcessingAccountSelection,
    isSavingProperty,
    
    // Methods - tüm i18n gerektiren metotları wrapper fonksiyonlar olarak geçiyoruz
    loadGoogleAccounts,
    loadGoogleProperties,
    selectAccount,
    selectProperty,
    accountSelected: () => accountSelected(t),
    savePropertySelection: () => saveGooglePropertySelection(t),
    goBackToAccounts,
    connectToGoogle: () => connectToGoogle(t),
    addNewGoogleAccount: () => addNewGoogleAccount(t),
    closeGoogleStatusModal,
    revokeAccount: (accountId, assetId) => revokeAccount(accountId, assetId, t),
    checkDuplicateAccount
  }
}